module.exports = __webpack_public_path__ + "img/no-data.e92cfed2.png";